export const toggleTokens = {
  'toggle-width': '40px',
  'toggle-height': '22px',
  'toggle-border-radius': 'var(--dp-border-radius-full)',
  'toggle-bg': 'var(--dp-color-border-strong)',
  'toggle-active-bg': 'var(--dp-color-primary)',
  'toggle-knob-size': '18px',
  'toggle-knob-color': '#fff',
  'toggle-knob-shadow': 'var(--dp-shadow-sm)',
  'toggle-transition': '0.2s ease',
  'toggle-disabled-opacity': '0.5',
} as const;
